export const EXCMCARUSERDATA_DELETE_RESET = 'EXCMCARUSERDATA_DELETE_RESET'
export const EXCMCARUSERDATA_DELETE_SET_ERROR = 'EXCMCARUSERDATA_DELETE_SET_ERROR'
export const EXCMCARUSERDATA_DELETE_SET_DELETED = 'EXCMCARUSERDATA_DELETE_SET_DELETED'
export const EXCMCARUSERDATA_DELETE_TOGGLE_LOADING = 'EXCMCARUSERDATA_DELETE_TOGGLE_LOADING'
